<coso-replicator-page-header [title]="'Groups'"></coso-replicator-page-header>
@if (isSaaS === false && isRunning) {
<alert type="warning">
  <coso-alert-message>You can only modify the content of this page once the replication process is stopped.</coso-alert-message>
</alert>
}
<alert type="info">
  <coso-alert-message>This page allows you to select SharePoint group(s) that each newly created SharePoint user will become member of. </coso-alert-message>
</alert>
@if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
} @if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message>{{ successMessage }}</coso-alert-message>
</alert>
}
<ng-container>
  <ng-container>
    <coso-grid [gridOptions]="gridOptions" [columnDefs]="columnDefs" [rowData]="rowData">
      <div topBarLeft>
        <button
          (click)="openAddModal()"
          id="createButton"
          class="btn btn-primary mr-2"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Add a new Group"
          [disabled]="initFailed || isReadOnly"
        >
          <span class="fa fa-plus mr-1" aria-hidden="true"></span>Add new
        </button>
        <button
          (click)="removeSelected()"
          class="btn btn-danger"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Remove these Groups. This action cannot be undone."
          [disabled]="isReadOnly || selectedRows.length === 0"
        >
          <span class="fa fa-trash mr-1" aria-hidden="true"></span>Remove selected
        </button>
      </div>
    </coso-grid>
    <a class="btn btn-dark mt-5" [routerLink]="['/', 'configuration', instanceId, 'connections']"><span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Connections list</a>
  </ng-container>
</ng-container>
